import type { LoginStrings } from "./login-strings";

const AUTH_ERROR_MAP: Record<string, keyof LoginStrings> = {
    "auth/wrong-password": "authWrongPassword",
    "auth/invalid-credential": "authWrongPassword",
    "auth/user-not-found": "authUserNotFound",
    "auth/email-already-in-use": "authEmailAlreadyInUse",
    "auth/weak-password": "authWeakPassword",
    "auth/too-many-requests": "authTooManyRequests",
    "auth/popup-closed-by-user": "authPopupClosed",
    "auth/cancelled-popup-request": "authPopupClosed",
    "auth/account-exists-with-different-credential": "authAccountExistsDifferentProvider",
    "auth/invalid-email": "authInvalidEmail",
    "auth/invalid-action-code": "authInvalidActionCode",
    "auth/expired-action-code": "authInvalidActionCode",
    "auth/network-request-failed": "authNetworkError",
    "auth/user-disabled": "authUserDisabled",
    "auth/operation-not-allowed": "authOperationNotAllowed",
    "auth/credential-already-in-use": "authCredentialAlreadyInUse",
};

export function authErrorMessage(code: string | undefined, strings: LoginStrings): string {
    if (!code) {
        return strings.genericError;
    }
    const key = AUTH_ERROR_MAP[code];
    return key ? strings[key] : strings.genericError;
}
